import React from 'react';
import { connect } from 'react-redux';
import style from './Loader.module.scss'; // Import css modules stylesheet as styles

const Loader = ({ msg, ...props }) => {
  const { i18n } = props;
  const { translations = {}, locale } = i18n || {};
  const t = translations[locale] || {};

  return (
    <div className={style.loader}>
      <div className={style.content}>
        <div className={style.loading} />
        <p className={style.message}>{t.loading}</p>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(Loader);

export { Loader as LoaderComponent }; // <- For component Unit Test
export default connectStore;
